export enum StatusRequestEnum{
    EXPIRED = 0,
    PENDING = 1,
    IN_PROGRESS = 2,
    CLOSED = 3,
    IN_CONTRACT = 4,
    IS_EXTENDABLE = 5
}